import { RichText } from 'prismic-reactjs';

export function linkResolver(doc) {
  if (doc.type === 'diensten') {
    return '/diensten';
  }
  return '/';
}

export function renderDataAsHtml(data) {
  return RichText.render(data, linkResolver);
}

export function renderDataAsPlainText(data) {
  return RichText.asText(data, linkResolver);
}



// WEBPACK FOOTER //
// ./src/api/renderPrismicData.js